import styled from 'styled-components'

export const Container = styled.div<{ size: 'small' | 'large' }>`
  display: flex;

  justify-content: center;
  align-items: center;

  border: 1px solid var(--border-transparent);
  border-radius: var(--radius-brand);

  padding: ${({ size }) => (size === 'small' ? '8px' : '19px')};

  background-color: var(--color-background);
`

export const Emoji = styled.img`
  width: 24px;
  height: 24px;
`
